import { storageFeatureOf } from "@/shared/lib/storage"

export interface StorageGroup {
	id: string
	label: string
	match: (key: string) => boolean
	warning?: string
}

const byPrefix =
	(...prefixes: string[]) =>
	(key: string) =>
		prefixes.some((prefix) => key.startsWith(prefix))

// Ключи `luni:…` группируются сами — по имени фичи из storageFeatureOf.
// Здесь ключи вне этой схемы (сторонние библиотеки, старые модули) и
// luni:-ключи, которые надо собрать в одну вкладку; группы проверяются первыми.
export const STORAGE_GROUPS: StorageGroup[] = [
	{
		// Старые ключи (rustore_pending_purchases, pending_web_payment) — от
		// версий до luni:-схемы; первый переносится при старте RuStore-сборки.
		id: "purchase",
		label: "Покупки",
		match: byPrefix(
			"luni:device:rustore-pending-purchases",
			"luni:session:pending-web-payment",
			"rustore_pending_purchases",
			"pending_web_payment",
		),
	},
	{
		id: "auth",
		label: "Сессия",
		match: byPrefix("access_token", "refresh_token", "owner_id", "user_id"),
		warning:
			"В браузере это выход из аккаунта. На iOS/Android токены лежат ещё и в SecureStorage — сессия не сбросится, для выхода используй логаут в приложении.",
	},
	{
		id: "locale",
		label: "Язык",
		match: byPrefix("PARAGLIDE_LOCALE"),
	},
	{
		id: "analytics",
		label: "Аналитика",
		match: byPrefix("ph_", "__ph"),
	},
	{
		id: "devtools",
		label: "Devtools",
		match: byPrefix("tanstack_devtools"),
	},
]

export const OTHER_GROUP_ID = "other"

export function groupOf(key: string): string {
	return (
		STORAGE_GROUPS.find((group) => group.match(key))?.id ??
		storageFeatureOf(key) ??
		OTHER_GROUP_ID
	)
}
